import { firestore } from 'firebase';

export function separateCamelCase(text) {
  return (
    text.charAt(0).toUpperCase() +
    text
      .substr(1)
      .replace(/([A-Z])/g, ' $1')
      .trim()
  );
}

export function formatTimeDate(dateOrTS, intl, showDate) {
  const options = {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  };

  if (showDate)
    Object.assign(options, {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
    });

  const date = dateOrTS instanceof firestore.Timestamp ? dateOrTS.toDate() : dateOrTS;

  return intl.formatTime(date, options);
}

export function pad(num, size=2) {
  num = num.toString();
  while (num.length < size) num = '0' + num;
  return num;
}
